import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TransportMeansFieldComponent, MaxDistanceFieldComponent } from "src/app/pages/register-user/shared/components";

@Component({
  selector: 'app-form-step-5',
  standalone: true,
  imports: [
    TransportMeansFieldComponent,
    MaxDistanceFieldComponent
],
  templateUrl: './form-step-5.component.html',
  styleUrls: ['./form-step-5.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormStep5Component {
  public form = input<FormGroup>();
}
